// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"5882c763","769":"a8b20558"}[chunkId] + ".chunk.js";
};